import {LOAD_CARD_DATA, DELETE_A_CARD, SAVE_A_CARD, UPDATE_A_CARD,CLEAR_A_CARD_ERROR_MESSAGE} from './actions';


const initialState = {
  cardsArray:[],
    deleteCardResp:{},
    errorCMsg:{},
    saveCardResp:{},
    updateCardResp:{}
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_CARD_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_CARD_DATA:
          return Object.assign({}, state, {
              cardsArray: action.cardsData
          });
          case DELETE_A_CARD:
          return Object.assign({}, state, {
              deleteCardResp: action.deleteCardResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_CARD:
          return Object.assign({}, state, {
              saveCardResp: action.saveCardResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_CARD:
          return Object.assign({}, state, {
              updateCardResp: action.saveCardResponse,
              errorCMsg: action.errorMsg
          });
    /*case LOAD_FARMS_SUCCESS:
      return {
        ...state,
        //all: [...action.payload.categories],  Farshid Uncommnet this out after you know teh payload from the server.
      };*/
    default:
      return state;
  }
}
